module.exports = ({ coverUrl, coverSize }) => coverUrl && coverSize.every(side => side)
